import { AppType } from "client/Api/Apps/common";
import { GridDimension } from "client/Api/Workspace/common";
import { range } from "client_legacy/ndaw/arrayHelpers";

export function getAvailableDimensions(appType: AppType): readonly GridDimension[] {
	// NOTE: Please keep this function in sync with "AppTypeHelper.cs"
	switch (appType) {
		case AppType.AddressBook:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 4, rowSpan: 10 },
				{ columnSpan: 4, rowSpan: 12 },
				{ columnSpan: 4, rowSpan: 16 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 10 },
				{ columnSpan: 6, rowSpan: 12 },
				{ columnSpan: 6, rowSpan: 16 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 10 },
				{ columnSpan: 8, rowSpan: 12 },
				{ columnSpan: 8, rowSpan: 16 }
			];
		case AppType.Afas:
		case AppType.Autotask:
		case AppType.ConnectWise:
		case AppType.Documents:
		case AppType.Email:
		case AppType.NedapOns:
		case AppType.Magister:
		case AppType.Office365Calendar:
		case AppType.SharePoint:
		case AppType.Teams:
		case AppType.ToDo:
		case AppType.TopDesk:
		case AppType.VilansKick:
		case AppType.Zaaksysteem:
		case AppType.ZenyaDoc:
		case AppType.Zermelo:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 }
			];
		case AppType.Embed:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 8 }
			];
		case AppType.Hub:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 10 },
				{ columnSpan: 8, rowSpan: 12 },
				{ columnSpan: 8, rowSpan: 16 },
				{ columnSpan: 17, rowSpan: 6 },
				{ columnSpan: 17, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 10 },
				{ columnSpan: 17, rowSpan: 12 }
			];
		case AppType.PowerBi:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 6 },
				{ columnSpan: 17, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 10 },
				{ columnSpan: 17, rowSpan: 12 }
			];
		case AppType.Birthday:
		case AppType.HowTo:
		case AppType.Integration:
		case AppType.Rss:
			return [
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 }
			];
		case AppType.YouTube:
			return [
				{ columnSpan: 4, rowSpan: 4 },
				{ columnSpan: 4, rowSpan: 6 },
				{ columnSpan: 4, rowSpan: 8 },
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 6 },
				{ columnSpan: 17, rowSpan: 8 },
				{ columnSpan: 17, rowSpan: 10 },
				{ columnSpan: 17, rowSpan: 12 }
			];
		case AppType.Google:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 },
				{ columnSpan: 4, rowSpan: 1 },
				{ columnSpan: 6, rowSpan: 1 },
				{ columnSpan: 8, rowSpan: 1 },
			];
		case AppType.Liquit:
		case AppType.Yammer:
			return [
				{ columnSpan: 6, rowSpan: 6 },
				{ columnSpan: 6, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 6 },
				{ columnSpan: 8, rowSpan: 8 },
				{ columnSpan: 8, rowSpan: 10 },
				{ columnSpan: 8, rowSpan: 12 },
				{ columnSpan: 8, rowSpan: 16 }
			];
		case AppType.AzureApp:
		case AppType.CitrixXenApp:
		case AppType.ClientlessRdp:
		case AppType.Office365Excel:
		case AppType.LocalApp:
		case AppType.Office365LyncMeeting:
		case AppType.Office365OneNote:
		case AppType.Office365PeopleScreen:
		case AppType.Office365PowerPoint:
		case AppType.Office365Word:
		case AppType.Url:
		case AppType.VmwareHorizonApp:
		case AppType.WindowsVirtualDesktop:
			return [
				{ columnSpan: 1, rowSpan: 1 },
				{ columnSpan: 2, rowSpan: 2 }
			];
		default:
			return [
				{ columnSpan: 2, rowSpan: 2 }
			];
	}
}

export function doesAppSupportCustomDimensions(type: AppType): boolean {
	switch (type) {
		case AppType.Embed:
			return true;
		default:
			return false;
	}
}

export const minCustomColSpan = 2;
export const minCustomRowSpan = 2;
export const maxCustomColSpan = 17;
export const maxCustomRowSpan = 17;

export const customColSpanValues: readonly number[] = range(minCustomColSpan, maxCustomColSpan + 1);
export const customRowSpanValues: readonly number[] = range(minCustomRowSpan, maxCustomRowSpan + 1);

export function isPredefinedDimension(appType: AppType, dimension: GridDimension): boolean {
	const { columnSpan, rowSpan } = dimension;

	return getAvailableDimensions(appType)
		.some(
			(x) => x.columnSpan === columnSpan
				&& x.rowSpan === rowSpan
		);
}

export function getPossibleDimensions(appType: AppType): readonly GridDimension[] {
	const predefinedDimensions: readonly GridDimension[] = getAvailableDimensions(appType);

	if (!doesAppSupportCustomDimensions(appType)) {
		return predefinedDimensions;
	}

	const allCustomDimensions: GridDimension[] = customRowSpanValues
		.flatMap(
			(rowSpan) => customColSpanValues
				.map((columnSpan): GridDimension => ({
					columnSpan,
					rowSpan
				}))
		);

	const predefinedDimensionsOutsideCustomRange: GridDimension[] = predefinedDimensions.filter(
		d => d.columnSpan < minCustomColSpan
			|| d.columnSpan > maxCustomColSpan
			|| d.rowSpan < minCustomRowSpan
			|| d.rowSpan > maxCustomRowSpan
	);

	return [
		...allCustomDimensions,
		...predefinedDimensionsOutsideCustomRange
	];
}

export function isAppInBeta(_type: AppType): boolean {
	return false;
}

export function isAppAvailableAsSpace(appType: AppType): boolean {
	switch (appType) {
		case AppType.Embed:
			return true;
		default:
			return false;
	}
}
